var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLockOff = function SvgLockOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.091,
    y: 7.664,
    width: 14.146,
    height: 10.607,
    rx: 3.278,
    stroke: "currentColor",
    strokeWidth: 1.435
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.486 5.279h1.399v2.455H5.486z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.489 5.368c0-1.078.43-2.118 1.208-2.922.779-.804 1.85-1.315 3.01-1.435a5.05 5.05 0 0 1 3.281.782c.199.13.59.459.68.879a.387.387 0 0 1-.087.31c-.245.322-.843.288-1.16.036a3.245 3.245 0 0 0-.241-.174 3.567 3.567 0 0 0-2.316-.552 3.453 3.453 0 0 0-2.126 1.013 2.964 2.964 0 0 0-.853 2.063H5.49ZM9.32 9.61c.245-.664 1.186-.664 1.432 0l.59 1.595c.078.21.242.374.452.452l1.594.59c.665.246.665 1.187 0 1.433l-1.594.59a.764.764 0 0 0-.452.451l-.59 1.595c-.246.665-1.187.665-1.433 0l-.59-1.595a.764.764 0 0 0-.451-.451l-1.595-.59c-.665-.246-.665-1.187 0-1.433l1.595-.59a.764.764 0 0 0 .451-.452l.59-1.594Z",
    fill: "currentColor"
  })));
};
export default SvgLockOff;